import React from "react";

const Bicycle = () => (
  <svg
    version="1.1"
    id="Layer_2_1_"
    x="0px"
    y="0px"
    viewBox="0 0 390 390"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M84.7,188.3C38,188.5,0,226.3,0,273s37.9,84.5,84.7,84.7c46.6-0.2,84.5-38.1,84.5-84.7S131.1,188.5,84.7,188.3z
		 M129.7,318.1c-11.5,11.7-27.4,19-45.1,19s-33.6-7.3-45.3-19c-11.5-11.5-18.8-27.4-18.8-45.1c0-17.6,7.3-33.6,18.8-45.1
		c11.7-11.7,27.7-18.8,45.3-18.8s33.6,7,45.1,18.8c11.7,11.5,18.8,27.4,18.8,45.1C148.6,290.7,141.5,306.6,129.7,318.1z"
      />
      <path d="M234.3,94.1c17,0,31-14,31-31s-14-30.8-31-30.8c-16.9,0-30.8,13.8-30.8,30.8C203.5,80.3,217.4,94.1,234.3,94.1z" />
      <path
        d="M291.5,168.9c18.5,0,18.5-24.4-0.8-24.4h-49.3l-33.5-55.6c-7.3-10-28.2-11.2-36.7-1.1l-59.8,59.6
		c-13.4,14.5-5.4,36,9.9,40.9l55.4,34.6v56.1c0,12.6,9.5,19.1,18.2,19.1c8.6,0,18.3-6.4,18.3-19.6v-71.7c0-6.5-0.9-14.1-6.4-16.3
		l-36.4-23l30.3-32l18.2,24.3c3.1,7.8,11.4,9.2,18,9.2L291.5,168.9L291.5,168.9z"
      />
      <g>
        <path
          d="M305.4,187c-46.7,0-84.7,37.9-84.7,84.6c0.2,46.7,37.9,84.7,84.7,84.7c46.6,0,84.6-38,84.6-84.7S352,187,305.4,187z
			 M350.6,316.8c-11.5,11.6-27.4,18.8-45.1,18.8s-33.6-7.2-45.3-18.8c-11.5-11.6-18.8-27.7-18.8-45.2c0-17.7,7.3-33.6,18.8-45.1
			c11.7-11.7,27.7-18.8,45.3-18.8c17.7,0,33.6,7,45.1,18.8c11.7,11.7,18.8,27.4,18.8,45.1C369.4,289.1,362.3,305.1,350.6,316.8z"
        />
      </g>
    </g>
  </svg>
);

export default Bicycle;
